<script lang="ts">
    import DonationList from '../../components/admin/donation/donationList.svelte';
  </script>
  
  <div class="donation-list-page">
    <DonationList />
  </div>
  
  <style>
    .donation-list-page {
      min-height: 100vh;
      background-color: #f9fafb;
    }
  </style>  